import PropTypes from "prop-types"
import CallMeForm from "components/forms/CallMeForm"
import Typography from "components/styled/Typography"
import { useLocale, useT } from "react-polyglot-hooks"
import { states } from "scenes/CarScene/Form"
import styled from "styled-components"

const Title = styled.div`
  margin-bottom: 25px;
`

function Form({ car, page, initialData, selectedPlan, setLeadData, setState }) {
  const { id, sold, sellingStatus } = car
  const locale = useLocale()
  const t = useT()

  return (
    <>
      <Title>
        <Typography variant="title3" color="white" weight="medium" className="mb-1">
          { sellingStatus !== 'flexible' ? t(`car_data.form.${sold ? "sold_title" : "title"}`) : t(`car_data.form.${sold ? "sold_title" : "flexible_title"}`)}
        </Typography>
        <Typography color="white">{t("car_data.form.subtitle")}</Typography>
      </Title>
      <CallMeForm
        formName={page}
        showEmail={!sold}
        showJobType
        initialData={initialData}
        extraData={{ price_id: selectedPlan.id, car_id: id, sellingStatus }}
        handleLoading={loading => setState(loading ? states.LOADING : states.FORM)}
        handleCompleted={data => {
          setLeadData(data)

          if (locale === "it") setState(states.CRIF)
          // else if (locale === "es" && !data.accepts_whatsapp) setState(states.WHATSAPP)
          // else if (data.last_web_leasing_request_id) goToOnline(data.last_web_leasing_request_id)
          else setState(states.DONE)
        }}
        cta={t("common.more_info")}
      />
    </>
  )
}

Form.propTypes = {
  car: PropTypes.object.isRequired,
  initialData: PropTypes.object.isRequired,
  page: PropTypes.string.isRequired,
  selectedPlan: PropTypes.object.isRequired,
  setLeadData: PropTypes.func.isRequired,
  setState: PropTypes.func.isRequired
}

export default Form
